const paths = {
  // new paths
  CONCLUSION_PATH: "/conclusion",
  CONTACT_PATH: "/contact",
  CULTURAL_BACKGROUND_PATH: "/cultural_background",
  HEALTH_AND_MEDICAL_PATH: "/health_and_medical",
  DIET_PATH: "/diet",
  GUEST_PACKAGES_PATH: "/guest_packages",
  GUEST_PREFERENCES_PATH: "/guest_preferences",
  GUEST_INTERACTION_LEVEL_PATH: "/guest_interaction_level",
  HOUSE_PATH: "/house",
  HOUSE_CONTINUED_PATH: "/house_continued",
  HOLDING_PATH: "/holding",
  INFO_PATH: "/info",
  INTERVAL_PATH: "/interval",
  PAYMENTS_PATH: "/payments",
  PETS_PATH: "/pets",
  PHOTO_PATH: "/photo",
  PROFILE_PATH: "/profile",
  REFERRAL_PATH: "/referral",
  REGISTER_PATH: "/register",
  ADDRESS_PATH: "/",
  RESIDENTS_PATH: "/residents",
  ROOMS_PATH: "/rooms",
  SMOKING_PATH: "/smoking",
  WITHDRAW_PATH: "/withdraw",
  PHONE_VERIFICATION_PATH: "/phone_verification",
  FAMILY_INTERESTS_PATH: "/family_interests",
  REFERENCES_PATH: "/references",
  FIREBASE_REGISTER_PATH: "/firebase_register",
  FIREBASE_DETAILS_PATH: "/firebase_details",
};

export default paths;
